import { useEffect, useState } from "react";
import { gapi, fmtDateTime, AUDIT_LABEL } from "../api";
import { PageHeader, Panel, Btn, Badge, inputCls } from "../components/ui";

const ESITO_TONE = { ok: "green", errore: "amber", negato: "red" };

export default function Registro() {
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [f, setF] = useState({ userId: "", azione: "", dal: "", al: "" });
  const [page, setPage] = useState(1);

  useEffect(() => { gapi.get("/users").then((r) => setUsers(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const params = { page, size: 30, userId: f.userId || undefined, azione: f.azione || undefined,
      dal: f.dal ? new Date(`${f.dal}T00:00:00`).toISOString() : undefined, al: f.al ? new Date(`${f.al}T23:59:59`).toISOString() : undefined };
    gapi.get("/audit", { params }).then((r) => setData(r.data));
  }, [f, page]);

  const set = (k) => (e) => { setPage(1); setF({ ...f, [k]: e.target.value }); };
  const pages = data ? Math.max(1, Math.ceil(data.total / data.size)) : 1;

  return (
    <div data-testid="g-audit-page">
      <PageHeader eyebrow="Amministrazione" title="Registro attività" desc="Accessi, tentativi falliti, modifiche ai permessi, inviti, download e operazioni rilevanti. Orari in fuso Europe/Rome." />
      <Panel className="mb-5">
        <div className="grid sm:grid-cols-4 gap-3">
          <select className={inputCls} value={f.userId} onChange={set("userId")} data-testid="g-audit-user"><option value="">Tutti gli utenti</option>{users.map((u) => <option key={u.id} value={u.id}>{u.nome}</option>)}</select>
          <select className={inputCls} value={f.azione} onChange={set("azione")} data-testid="g-audit-action"><option value="">Tutte le operazioni</option>{(data?.azioni || []).map((a) => <option key={a} value={a}>{AUDIT_LABEL[a] || a}</option>)}</select>
          <input type="date" className={inputCls} value={f.dal} onChange={set("dal")} data-testid="g-audit-from" />
          <input type="date" className={inputCls} value={f.al} onChange={set("al")} data-testid="g-audit-to" />
        </div>
      </Panel>
      <Panel>
        {!data ? <p className="text-sm">Caricamento…</p> : (
          <>
            <div className="overflow-x-auto -mx-5 sm:mx-0">
              <table className="w-full text-sm min-w-[720px]">
                <thead><tr className="text-left text-xs uppercase tracking-wider text-anthracite/45"><th className="py-2 px-5 sm:px-2">Data e ora</th><th className="px-2">Utente</th><th className="px-2">Operazione</th><th className="px-2">Esito</th><th className="px-2">IP</th></tr></thead>
                <tbody className="divide-y divide-border-subtle">
                  {data.items.map((a) => (
                    <tr key={a.id} data-testid="g-audit-row">
                      <td className="py-2.5 px-5 sm:px-2 whitespace-nowrap">{fmtDateTime(a.at)}</td>
                      <td className="px-2">{a.userNome || a.userEmail || "Sistema"}</td>
                      <td className="px-2">{AUDIT_LABEL[a.azione] || a.azione}{a.dettagli?.utente ? ` · ${a.dettagli.utente}` : ""}{a.dettagli?.email ? ` · ${a.dettagli.email}` : ""}</td>
                      <td className="px-2"><Badge tone={ESITO_TONE[a.esito] || "neutral"}>{a.esito}</Badge></td>
                      <td className="px-2 text-anthracite/50">{a.ip}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="flex items-center justify-between mt-4 text-sm">
              <span className="text-anthracite/50" data-testid="g-audit-total">{data.total} operazioni</span>
              <span className="flex items-center gap-2">
                <Btn variant="ghost" disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedente</Btn>
                <span>{page} / {pages}</span>
                <Btn variant="ghost" disabled={page >= pages} onClick={() => setPage(page + 1)}>Successiva</Btn>
              </span>
            </div>
          </>
        )}
      </Panel>
    </div>
  );
}
